import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-g_home_on",
  "use": "icon-g_home_on-usage",
  "viewBox": "0 0 1152 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1152 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-g_home_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M1102.08 401.728L648.448 23.616c-38.784-31.488-104.704-31.488-143.424 0L47.488 405.76c-15.488 7.872-19.392 27.52-11.584 43.264 3.84 15.808 19.328 23.68 34.88 23.68h38.784V921.6c0 59.072 42.624 102.4 100.8 102.4h248.128c23.232 0 38.72-15.744 38.72-39.36v-181.184c0-27.52 42.688-55.168 77.568-55.168 34.88 0 81.408 27.584 81.408 55.168v181.12c0 23.68 15.552 39.424 38.784 39.424h252.032c58.112 0 96.896-39.36 96.896-102.4V472.64h38.784a37.376 37.376 0 0 0 34.88-27.584 39.68 39.68 0 0 0-15.488-43.328z\" p-id=\"5617\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/g_home_on.svg
// module id = lYsg
// module chunks = 31